import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useToast } from '../../../hooks/toast';
import { Spin } from 'antd';
import CampaignCreateEdit from './CreateEdit';
import {
  ICrmCampaign,
  getCrmCampaignById,
} from '../../../http/crm';

const CampaignsEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { addToast } = useToast();
  const [campaign, setCampaign] = useState<ICrmCampaign | null>(null);
  const [, setCampaignsList] = useState<ICrmCampaign[]>([]);
  const [loading, setLoading] = useState(Boolean(id && id !== 'new'));

  const close = useCallback(() => navigate('/crm/campaigns'), [navigate]);

  useEffect(() => {
    let cancelled = false;
    if (id === 'new' || !id) {
      setCampaign(null);
      setLoading(false);
      return;
    }
    (async () => {
      try {
        const data = await getCrmCampaignById(id);
        if (!cancelled) setCampaign(data);
      } catch (error: any) {
        if (!cancelled) {
          addToast({
            type: 'error',
            title: 'Erro',
            description:
              error?.response?.data?.error ??
              'Não foi possível carregar a campanha.',
          });
          close();
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [id, addToast, close]);

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  return (
    <CampaignCreateEdit
      open
      close={close}
      campaign={campaign}
      setCampaigns={setCampaignsList}
      onSaved={close}
    />
  );
};

export default CampaignsEdit;
